import React, { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Spin, Empty } from "antd";
import { useQuery } from "@tanstack/react-query";
import vendorConversationAPI from "../lib/api/vendorConversationAPI";

/**
 * Unauthenticated vendor flow: ?vendorId=… → find maintenance_group conversation and redirect.
 */
const RepairVendorConversationRedirect = ({ ticketId, vendorId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const userId = vendorId || null;
  const userType = "vendor";

  const { data, isLoading } = useQuery({
    queryKey: ["repairConversationSearch", userId, userType],
    queryFn: () =>
      vendorConversationAPI.searchConversations({
        userId,
        userType,
        conversationType: "maintenance_group",
        limit: 50,
      }),
    enabled: !!userId,
  });

  useEffect(() => {
    if (!isLoading && data) {
      const conversations = data?.conversations || data?.results || [];
      const match = conversations.find(
        (c) =>
          c?.context?.relatedTicketId === ticketId || c?.ticketId === ticketId
      );
      if (match?.id) {
        navigate(`/conversations/${match.id}${location.search}`);
      }
    }
  }, [isLoading, data, ticketId, navigate, location.search]);

  if (!userId || isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "70vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "70vh",
      }}
    >
      <Empty description="This ticket’s conversation hasn’t been created yet." />
    </div>
  );
};

export default RepairVendorConversationRedirect;
